<template>
  <BuiEntityListingPage
    entityItemsNamePlural="Users"
    entityItemName="User"
    areaAccessName="Administration"
    :createItemPage="true"
    @create="createUser()"
    :ItemsLister="UsersLister"
    :itemsListerBind="{ buiColumns: usersColumns }"
  />
</template>

<script lang="ts" setup>
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import router from '@/router';
import UsersLister from './UsersLister/UsersLister.vue';
import usersColumns from "./UsersLister/config/tableColumns.config";

function createUser() {
  router.push('users/create');
}
</script>

<style lang="scss" scoped>
</style>
